import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'ngx-one-column-layout',
    styleUrls: ['./one-column.layout.scss'],
    template: `
    <nb-layout windowMode>
      @if (!isGeneratorEdit) {
        <nb-layout-header fixed>
          <ngx-header></ngx-header>
        </nb-layout-header>
      }
    
      @if (!isGeneratorEdit) {
        <nb-sidebar class="menu-sidebar" tag="menu-sidebar" state="compacted">
          <ng-content select="[menu]"></ng-content>
        </nb-sidebar>
      }
    
      <nb-layout-column [class.fullscreen]="isGeneratorEdit">
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>
    </nb-layout>
    `,
    standalone: false
})
export class OneColumnLayoutComponent {
  constructor(private router: Router) {}

  get isGeneratorEdit(): boolean {
    const url = this.router.url;
  
    return (
      (
        url.startsWith('/pages/generator/') &&
        !url.includes('/folder/')
      )
      || url.startsWith('/pages/generator-v2')
      || url.startsWith('/pages/modules/')
    );
  }
  
}
